const A = "https://customer-assets-m6fa6gv7.emergentagent.net/job_filmmakerakki/artifacts";
const C = "https://thumb.wikimedia.org/wikipedia/commons/thumb";

// Hero — Akki with DJI Inspire in the Himalayas (his real photo, uploaded by user)
export const HERO_BG = "/assets/hero-main.jpg";

// About — real on-set photo of Akhilesh Kumar Suman (Ghamasaan clapperboard, uploaded by user; rendered B&W via CSS)
export const ABOUT_IMG = "/assets/about-main.jpg";

// About — far-right aerial / on-location thumbnails
export const ABOUT_THUMBS = [
  { src: `${A}/7lfq9vd5_Screenshot%202026-09-01%20at%202.59.49%E2%80%AFAM.png`, alt: "DJI Inspire mountain shoot" },
  { src: `${A}/a42pyai9_Screenshot%202026-09-01%20at%202.57.24%E2%80%AFAM.png`, alt: "Drone crew outdoor shoot" },
  { src: `${A}/2rws6fc3_Screenshot%202026-09-01%20at%202.58.25%E2%80%AFAM.png`, alt: "Rooftop drone operation city shoot" },
  { src: `${A}/nzaw9cbo_Screenshot%202026-09-01%20at%202.57.42%E2%80%AFAM.png`, alt: "Jib unit wedding set" },
];

export const STATS = [
  { icon: "clapperboard", value: "26+", label: "Major Productions" },
  { icon: "calendar", value: "9+", label: "Years of Experience" },
  { icon: "users", value: "50+", label: "Happy Clients" },
  { icon: "chart", value: "1M+", label: "Views Across Platforms" },
];

export const HERO_SIDE_LIST = ["Films", "OTT", "Government", "Commercials", "Behind the Scenes"];

// Equipment — real photos via Wikimedia Commons (Mavic 3 Pro airframe photos stand in for Classic/Cine; Inspire 2 for Inspire 3)
export const EQUIPMENT = [
  {
    name: "DJI Inspire 3",
    sub: "Cinema Flagship",
    highlights: ["Zenmuse X9 Full Frame Camera", "8K ProRes RAW", "Interchangeable Cinema Lenses", "Feature Film Production"],
    img: `${C}/a/a5/2019-03-23_-_DJI_Inspire_2_-3986.jpg/960px-2019-03-23_-_DJI_Inspire_2_-3986.jpg`,
    hero: true,
  },
  {
    name: "DJI Mavic 4 Pro Creator Combo",
    sub: "Professional Aerial Work",
    highlights: ["Advanced Large Sensor", "5.1K Recording", "Intelligent Tracking", "Professional Aerial Work"],
    img: `${C}/a/a8/DJI_-_Drohne_Mavic_4_Pro.JPG/960px-DJI_-_Drohne_Mavic_4_Pro.JPG`,
  },
  {
    name: "DJI Mavic 3 Cine",
    sub: "Commercial Cinema",
    highlights: ["Apple ProRes Workflow", "5.1K Cinema Recording", "Professional Commercial Shoots"],
    img: `${C}/e/e8/2024-10-_DJI_Mavic_3_Pro_-_10.jpg/960px-2024-10-_DJI_Mavic_3_Pro_-_10.jpg`,
  },
  {
    name: "DJI Mavic 3 Classic",
    sub: "Everyday Cinema Workhorse",
    highlights: ["4/3 CMOS Sensor", "5.1K Recording", "Extended Flight Performance"],
    img: `${C}/9/94/2024-10-_DJI_Mavic_3_Pro_-_09.jpg/960px-2024-10-_DJI_Mavic_3_Pro_-_09.jpg`,
  },
  {
    name: "DJI Avata 2 (FPV)",
    sub: "Action Cinematography",
    highlights: ["FPV Cinematic Flying", "155° Ultra-wide View", "Action Cinematography"],
    img: `${C}/4/46/DJI_AVATA_2.jpg/960px-DJI_AVATA_2.jpg`,
  },
];

export const SERVICES = [
  {
    title: "Wedding Films",
    sub: "Emotional cinematic storytelling",
    features: ["Drone + ground coverage", "Premium film finish", "Same-day teaser edit"],
    img: `${A}/5c06c8xr_Screenshot%202026-09-01%20at%202.59.16%E2%80%AFAM.png`,
  },
  {
    title: "Drone Cinematography",
    sub: "Feature film quality aerials",
    features: ["Commercial aerial coverage", "Smooth cinematic movements", "Licensed & insured ops"],
    img: `${A}/7lfq9vd5_Screenshot%202026-09-01%20at%202.59.49%E2%80%AFAM.png`,
  },
  {
    title: "Brand Commercials",
    sub: "Product films & campaigns",
    features: ["Campaign shoots", "Premium brand storytelling", "Agency-grade delivery"],
    img: `${C}/7/75/Purple_road_%28Unsplash%29.jpg/960px-Purple_road_%28Unsplash%29.jpg`,
  },
  {
    title: "Real Estate",
    sub: "Luxury property showcases",
    features: ["Interior + aerial coverage", "Marketing-ready visuals", "Fast 48h turnaround"],
    img: `${A}/2rws6fc3_Screenshot%202026-09-01%20at%202.58.25%E2%80%AFAM.png`,
  },
  {
    title: "Travel & Tourism",
    sub: "Destination films",
    features: ["Tourism campaigns", "Adventure storytelling", "Breathtaking landscapes"],
    img: `${C}/9/9b/Begnas_Lake%2C_Pokhara%2C_Kaski.jpg/960px-Begnas_Lake%2C_Pokhara%2C_Kaski.jpg`,
  },
  {
    title: "Documentary Production",
    sub: "Government projects",
    features: ["Cultural stories", "Real-world narratives", "Broadcast-ready output"],
    img: `${C}/d/d8/Rashtrapati_Bhavan_1.jpg/960px-Rashtrapati_Bhavan_1.jpg`,
  },
];

// CTA — Himalayan panorama (Wikimedia Commons)
export const CTA_IMG = `${C}/2/2b/120408_Pheriche_Pano_4k.jpg/1920px-120408_Pheriche_Pano_4k.jpg`;

export const CONTACT = {
  email: "akhileshkumar504@gmail.com",
  phone: "+91-7897862633",
  location: "India",
  imdb: "https://www.imdb.com/find/?q=Akhilesh%20Kumar%20Suman",
  linkedin: "https://www.linkedin.com/in/akhilesh-kumar-suman",
};

export const FOOTER_SERVICES = [
  "Film & OTT",
  "Documentary",
  "Commercial",
  "Real Estate",
  "Travel & Tourism",
  "Drone Services",
  "Consultation",
];
